module.exports = __webpack_public_path__ + "assets/0b30c5aaefc82da1313e479693ad90a1.json";